/* 🤖 this file was generated by svg-to-ts */
export const matIconVoiceChat: {
  name: 'voice-chat';
  data: string;
} = {
  name: 'voice-chat',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-6-5.4 3 2.4V7l-3 2.4V7H7v6h7z"/></svg>`
};
